module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "02addremove.6db2b144.png" + "?" + Date.now();